import { Directive, input } from '@angular/core';

export const NumberInputFormControlDirectiveInputs = ['max', 'min', 'step', 'hideControls'];

@Directive({
  selector: '[uiNumberInputFormControl]',
  standalone: true,
})
export class NumberInputFormControlDirective {
  readonly max = input<number | null>(null);

  readonly min = input<number | null>(null);

  readonly step = input(0.1);

  readonly hideControls = input(false);
}
